export default "__VITE_ASSET__BBTdyVcx__"